import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type FixedContainerProps = {
	className?: string;
	children: any;
	hasShadow?: boolean;
	top?: number;
};

export const FixedContainer = ({
	children,
	className,
	hasShadow,
	top = 64,
}: FixedContainerProps) => {
	const boxShadowClass = hasShadow ? styles.boxShadowClass : "";
	return (
		<div
			className={clsx(styles.fixedContainer, className, boxShadowClass)}
			style={{ top: `${top}px` }}
		>
			{children}
		</div>
	);
};
